import { Box } from '@chakra-ui/react';
import { Group, Loader, Text } from '@melio/penny';
import { useAnalytics } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-provider';
import { forwardRef, useOneTimeEffect } from '@melio/platform-utils';
import platform from 'platform';

import { NewSinglePaymentStepLayout } from '../../../../NewSinglePaymentStepLayout';

export const BillFileProcessingScreen = forwardRef((props, ref) => {
  const { formatMessage } = useMelioIntl();
  const { createTrackHandler } = useAnalytics();

  const track = createTrackHandler<{ os: string }>('ProccessUploadedBill', 'Viewed');

  useOneTimeEffect(
    () => {
      track({ os: platform.os?.toString() });
    },
    () => true,
    [track]
  );

  return (
    <NewSinglePaymentStepLayout
      data-component="AddOcrBillActivity.BillFileProcessingScreen"
      data-testid="add-ocr-bill-activity-bill-file-processing-screen"
      {...props}
      ref={ref}
    >
      <Box style={{ marginTop: '50vh', transform: 'translateY(-50%)' }}>
        <Group variant="vertical" alignItems="center">
          <Loader />
          <Group variant="vertical" spacing="none" alignItems="center">
            <Text textStyle="body3Semi">{formatMessage('activities.addOcrBill.screens.billFileProcessing.title')}</Text>
            <Text textStyle="body3" color="neutral.darkest">
              {formatMessage('activities.addOcrBill.screens.billFileProcessing.description')}
            </Text>
          </Group>
        </Group>
      </Box>
    </NewSinglePaymentStepLayout>
  );
});

BillFileProcessingScreen.displayName = 'AddOcrBillActivity.BillFileProcessingScreen';
